import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Identity } from '../../viewmodels/login/identity';
import { OIDCProvider } from '../../viewmodels/login/oidcProvider';
import { User } from '../../viewmodels/login/user';
import { BackendService } from '../backend.service';
import { CONFIG } from '../config';
import { ConfigService } from '../config.service';
import { ApiResult } from '../messages/api-result';
import { PermissionsService } from '../permissions.service';


@Injectable()
export class AuthService {
  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loggedInUser: BehaviorSubject<string> = new BehaviorSubject('');
  public ssoProviders: BehaviorSubject<OIDCProvider[]> = new BehaviorSubject<OIDCProvider[]>(null);

  constructor(
    private configService: ConfigService,
    private permissionService: PermissionsService,
    private backendService: BackendService,
  ) {
    if (this.authenticated) {
      this.loggedInUser.next(this.configService.currentUser.getValue());
      this.loggedIn.next(true);
    } else if (this.loggedIn.getValue()) {
      this.logout();
    }
  }

  public hideSpinner() {
    this.backendService.spinner.hide();
  }

  public setCatalog(value: string) {
    this.configService.setCatalog(value);
  }

  public resetPassword(currentPassword: string, newPassword: string): Observable<User> {
    const currentUser = this.loggedInUser.getValue();

    if (!currentUser || !currentPassword || !newPassword) {
      return;
    }

    return this.backendService.resetUserPassword(currentUser, [currentPassword, newPassword]);
  }

  public passwordAlreadyResetted() {
    this.configService.setAlreadyReset(true);
  }

  public clearLoginSession() {
    this.configService.setCurrentUser('');
    this.configService.setUserId('');
    this.configService.setUserCatalogs([]);
    this.configService.setCatalog('');
    this.configService.setAlreadyReset(false);

    this.configService.setResetRequired(false);
    this.configService.setUsingLoginProvider(false);
  }

  public logout() {
    window.location.href = window.location.origin + CONFIG.routes.authLogout;
  }

  get authenticated(): boolean {
    const catalogs = this.configService.userCatalogs.getValue();
    return catalogs && catalogs.length > 0;
  }

  get userName(): string {
    return this.configService.currentUser.getValue();
  }

  get userId(): string {
    return this.configService.userId.getValue();
  }

  get catalog(): string {
    return this.configService.selectedCatalog.getValue();
  }

  get urlCatalog(): string {
    return '/' + this.configService.selectedCatalog.getValue();
  }

  get resetPasswordRequired(): boolean {
    return this.configService.resetRequired.getValue();
  }

  public getSOProviders(): Observable<OIDCProvider[]> {
    return this.backendService.getAllByIdIdentity<OIDCProvider>(OIDCProvider, this.catalog, CONFIG.apiRoutes.ssoProviders);
  }

  public setpermissions() {
    this.backendService.get<Identity>(Identity).subscribe(
      (data: Identity) => {
        this.permissionService.SetPermissions(data);
      },
      (errorResult: ApiResult) => {
        if (errorResult) {
          console.log('error ' + errorResult)
        }
      },
    );
  }
}
